import { BodyRegular, HealLine3, WarningText } from "../../shared/typography";
import { Col, Row } from "../Assets/style";
import noItemImage from "./../../assets/notFoundImages/No item found.png";
import { ImgComp } from "./style";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import { CustomTextbar } from "../../components/CustomTextbar";
import { ReactComponent as ChromeIcon } from "../../assets/icons/browsers/chrome-logo.svg";
import { ReactComponent as FirefoxIcon } from "../../assets/icons/browsers/firefox_logo.svg";
import { ReactComponent as BraveIcon } from "../../assets/icons/browsers/brave-icon.svg";
import { ReactComponent as OperaIcon } from "../../assets/icons/browsers/opera-icon.svg";
import { ReactComponent as EdgeIcon } from "../../assets/icons/browsers/edge-logo.svg";

const BrowerNotSupported = () => {
    const currentURL = window?.location?.origin;
    console.log('Current URL:', currentURL);
    return (
        <>
            <Nav />
            <Col padding="100px 0 0 0" align="center">
                <ImgComp
                    src={noItemImage}
                    alt='no-asset-found'
                />
                <HealLine3>Your browser does not support MetaMask.</HealLine3>
                <BodyRegular>Please open the app using one of the browsers listed below:</BodyRegular>
                <Row>
                    <Col align="center">
                        <ChromeIcon />
                        <WarningText>Chrome</WarningText>
                    </Col>
                    <Col align="center">
                        <BraveIcon />
                        <WarningText>Brave</WarningText>
                    </Col>
                    <Col align="center">
                        <FirefoxIcon />
                        <WarningText>Firefox</WarningText>
                    </Col>
                    <Col align="center">
                        <EdgeIcon />
                        <WarningText>Edge</WarningText>
                    </Col>
                    <Col align="center">
                        <OperaIcon />
                        <WarningText>Opera</WarningText>
                    </Col>
                </Row>
                <CustomTextbar isHideDots config={{ title: 'You can copy the URL from here', value: currentURL }} link={'/'} />
            </Col>
            <Footer />
        </>
    )
}

export default BrowerNotSupported;